import contentfulImageLoader from '@segment/utils/contentfulImageLoader/contentfulImageLoader';
import * as views from './Logo.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var defaultImageSizes = {
  width: 136,
  height: 48
};
export var Logo = function Logo(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  return _jsx(views.Logo, {
    loader: contentfulImageLoader,
    width: width && height ? width : defaultImageSizes.width,
    height: width && height ? height : defaultImageSizes.height,
    loading: "lazy",
    src: src,
    alt: alt || ""
  });
};